// i18n keys of the multi-tenant work package "consultcal" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  ccs_title: 'Consultation appointments',
  ccs_hint: 'Consultation invoices are emailed from one of your mailboxes with the client on To. We read the day, time and length out of each one and put the appointment in a calendar, with the client invited as a guest. One appointment per invoice number: the same invoice sent again moves it, and an appointment taken off the calendar is never put back.',
  ccs_mailbox: 'Invoice mailbox',
  ccs_mailbox_none: '— Not set (no appointments are made) —',
  ccs_mailbox_hint: 'One of the mailboxes connected in the Email module. Both its Inbox and its Sent folder are read, because the invoice usually goes out from it.',
  ccs_not_connected: 'not connected',
  ccs_calendar: 'Calendar',
  ccs_calendar_none: '— Not set (no appointments are made) —',
  ccs_calendar_hint: 'One of the calendars on the Calendar page. The appointment is written there and the invitation to the client comes from that calendar’s own address.',
  ccs_ready: 'Reading {{mailbox}} · appointments go to {{calendar}}.',
  ccs_last_run: 'Last checked {{when}} — {{seen}} invoice(s) seen, {{made}} appointment(s) made, {{moved}} moved.',
  ccs_last_run_never: 'The mailbox has not been checked yet.',
  ccs_check: 'Check now',
  ccs_checking: 'Checking…',
  ccs_test_summary: '{{scanned}} email(s) read, {{found}} consultation invoice(s) found, {{stale}} too old to act on. Nothing was written and nobody was emailed.',
  ccs_minutes: '{{n}} min',
  ccs_save: 'Save',
  ccs_saving: 'Saving…',
  ccs_saved: 'Saved',
};
export const zh: Record<string, string> = {
  ccs_title: '咨询预约',
  ccs_hint: '咨询发票由你的某个邮箱发出,收件人(To)是客户。系统从每封邮件里读出日期、时间和时长,把预约写进日历,并把客户作为与会人邀请。每个发票号只建一条预约:同一张发票再次发出会移动预约;已从日历删除的预约不会被重建。',
  ccs_mailbox: '发票邮箱',
  ccs_mailbox_none: '— 未设置(不会建任何预约)—',
  ccs_mailbox_hint: '从邮件模块里已连接的邮箱中选一个。收件箱和已发送都会读取,因为发票通常是从这个邮箱发出的。',
  ccs_not_connected: '未连接',
  ccs_calendar: '日历',
  ccs_calendar_none: '— 未设置(不会建任何预约)—',
  ccs_calendar_hint: '从日历页面的日历中选一个。预约写在那里,给客户的邀请也从该日历自己的邮箱地址发出。',
  ccs_ready: '读取 {{mailbox}} · 预约写入 {{calendar}}。',
  ccs_last_run: '上次检查 {{when}} —— 发现 {{seen}} 张发票,新建 {{made}} 条预约,移动 {{moved}} 条。',
  ccs_last_run_never: '还没有检查过这个邮箱。',
  ccs_check: '立即检查',
  ccs_checking: '检查中…',
  ccs_test_summary: '读取了 {{scanned}} 封邮件,找到 {{found}} 张咨询发票,其中 {{stale}} 张太旧、不再处理。没有写入任何内容,也没有发出任何邮件。',
  ccs_minutes: '{{n}} 分钟',
  ccs_save: '保存',
  ccs_saving: '保存中…',
  ccs_saved: '已保存',
};
export const th: Record<string, string> = {
  ccs_title: 'นัดหมายการให้คำปรึกษา',
  ccs_hint: 'ใบแจ้งหนี้ค่าให้คำปรึกษาถูกส่งออกจากกล่องอีเมลของคุณ โดยมีลูกค้าอยู่ในช่อง To ระบบจะอ่านวัน เวลา และระยะเวลาจากอีเมลแต่ละฉบับ แล้วสร้างนัดหมายในปฏิทิน พร้อมเชิญลูกค้าเป็นผู้เข้าร่วม หนึ่งเลขที่ใบแจ้งหนี้ต่อหนึ่งนัดหมาย: หากส่งใบแจ้งหนี้เดิมอีกครั้ง นัดหมายจะถูกย้าย และนัดหมายที่ถูกลบออกจากปฏิทินจะไม่ถูกสร้างขึ้นใหม่',
  ccs_mailbox: 'กล่องอีเมลใบแจ้งหนี้',
  ccs_mailbox_none: '— ยังไม่ตั้งค่า (จะไม่สร้างนัดหมายใด ๆ) —',
  ccs_mailbox_hint: 'เลือกหนึ่งในกล่องอีเมลที่เชื่อมต่อไว้ในโมดูลอีเมล ระบบจะอ่านทั้งกล่องขาเข้าและกล่องขาออก เพราะใบแจ้งหนี้มักถูกส่งออกจากกล่องนี้',
  ccs_not_connected: 'ไม่ได้เชื่อมต่อ',
  ccs_calendar: 'ปฏิทิน',
  ccs_calendar_none: '— ยังไม่ตั้งค่า (จะไม่สร้างนัดหมายใด ๆ) —',
  ccs_calendar_hint: 'เลือกหนึ่งในปฏิทินจากหน้าปฏิทิน นัดหมายจะถูกบันทึกไว้ที่นั่น และคำเชิญที่ส่งถึงลูกค้าจะมาจากที่อยู่อีเมลของปฏิทินนั้น',
  ccs_ready: 'อ่าน {{mailbox}} · นัดหมายไปที่ {{calendar}}',
  ccs_last_run: 'ตรวจครั้งล่าสุด {{when}} — พบใบแจ้งหนี้ {{seen}} ฉบับ สร้างนัดหมาย {{made}} รายการ ย้าย {{moved}} รายการ',
  ccs_last_run_never: 'ยังไม่ได้ตรวจกล่องอีเมลนี้',
  ccs_check: 'ตรวจเดี๋ยวนี้',
  ccs_checking: 'กำลังตรวจ…',
  ccs_test_summary: 'อ่านอีเมล {{scanned}} ฉบับ พบใบแจ้งหนี้ค่าให้คำปรึกษา {{found}} ฉบับ โดย {{stale}} ฉบับเก่าเกินกว่าจะดำเนินการ ไม่มีการบันทึกข้อมูลและไม่มีการส่งอีเมลถึงใคร',
  ccs_minutes: '{{n}} นาที',
  ccs_save: 'บันทึก',
  ccs_saving: 'กำลังบันทึก…',
  ccs_saved: 'บันทึกแล้ว',
};
